export const domain = 'ScheduleModel';

export const onFetchScheduleData = `${domain}/onFetchScheduleData`;
export const onFetchScheduleDataSuccess = `${domain}/onFetchScheduleDataSuccess`;
